module.exports = __webpack_public_path__ + "static/media/view_edit_icon.1a6a2ad1.svg";